import React, {useContext} from "react";
import {TimelineFrameDataContext} from "../../../../../TimelineFramePage";
import {
    TYPE_GTI,
    TYPE_VIDEO_CONFERENCE
} from "../../../../../../../definitions/TimelineItems";
import {FormattedMessage} from "react-intl";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {selectIsHpa} from "../../../../../../../data/hpa/selectors";
import {getGtiAppointmentStatus} from "../../../../../../../data/util";
import OTIcon from "../../../../../../../components/tag/OTIcon";
import classnames from "classnames";
import {showGtiBeginModal} from "../../../../../../../data/service/gti/actions";
import TimelineFrameContentCanBeRescheduled from "./TimelineFrameContentCanBeRescheduled";
import TimelineFrameContentCareUnitWrapper from "../../careunitdetails/TimelineFrameContentCareUnitWrapper";
import Row from "../../../../../../../components/tag/Row";
import Span from "../../../../../../../components/tag/Span";
import Loader from "../../../../../../../components/Loader";
import {
    COXA_GENERIC_APPOINTMENT_SEGMENT_PHRASE_KEYWORD,
    COXA_GENERIC_PHRASE_TYPE
} from "../../../../../TimelineFrameUtils";
import TimelineFrameContentAppointmentCareUnit from "./TimelineFrameContentAppointmentCareUnit";

const TimelineFrameContentVideoConferenceSpecific = () => {
    return (
        <>
            <TimelineFrameContentCanBeRescheduled />
            <TimelineFrameContentCareUnitWrapper>
                <TimelineFrameContentAppointmentCareUnit />
            </TimelineFrameContentCareUnitWrapper>
        </>
    );
}

const TimelineFrameContentGTISpecific = ({data, isHpa, showGtiBeginModal}) => {
    const status = getGtiAppointmentStatus(data);
    if(status != null && !isHpa) {
        return (
            <>
                <TimelineFrameContentCanBeRescheduled />
                <TimelineFrameContentCareUnitWrapper>
                    <TimelineFrameContentAppointmentCareUnit />
                </TimelineFrameContentCareUnitWrapper>
                <br/>
                <div className="row-fluid">
                    <div className="span12">
                        <OTIcon
                            className={'card-icon'}
                            config={{ type: 'custom', name: 'kyselyt', color: 'lightblue' }}
                        />
                        <button
                            disabled={status === 'INACTIVE'}
                            onClick={showGtiBeginModal}
                            className={classnames(
                                'card-link',
                                'gti-link',
                                status === 'INACTIVE' && 'gti-link--inactive'
                            )}
                        >
                            <FormattedMessage id={'gti.timelineitem.title'} />
                        </button>
                        <br />
                        <span className={'gti-link-description'}>
                            <FormattedMessage id={'gti.link.message'} />
                        </span>
                    </div>
                </div>
            </>
        );
    }
    return null;
}

const TimelineFrameContentCoxaSpecificInfo = () => {
    const { genericPhrases } = useContext(TimelineFrameDataContext);
    const coxaGenericPhrases = genericPhrases.find(e => e.type === COXA_GENERIC_PHRASE_TYPE);

    if (coxaGenericPhrases) {
        const coxaAppointmentSegmentGenericPhrase =
            coxaGenericPhrases.phrases.find(p => p.key.includes(COXA_GENERIC_APPOINTMENT_SEGMENT_PHRASE_KEYWORD));

        if (coxaAppointmentSegmentGenericPhrase) {
            return (
                <Row>
                    <Span>
                        <p>{coxaAppointmentSegmentGenericPhrase.value}</p>
                    </Span>
                </Row>

            )
        }
    }

    return <></>;
}

const TimelineFrameContentDefaultSpecificInfo = () => {
    return (
        <>
            <TimelineFrameContentCanBeRescheduled />
            <TimelineFrameContentCareUnitWrapper>
                <TimelineFrameContentAppointmentCareUnit />
            </TimelineFrameContentCareUnitWrapper>
        </>
    )

}

const TimelineFrameContentEventSpecificInfo = ({isHpa, showGtiBeginModal}) => {
    const { data, linkkipalvelu } = useContext(TimelineFrameDataContext);

    const isCoxa = () => {
        if(linkkipalvelu.Logot && linkkipalvelu.Logot[data.oid] === 'fetching' ||
            linkkipalvelu.Logot && linkkipalvelu.Logot[data.oid] === undefined) {
            return false;
        }
        const c = linkkipalvelu.Logot && linkkipalvelu.Logot[data.oid];
        return "COXA" === c[0].toString();
    }

    const getEventTypeSpecificInformation = () => {

        if (isCoxa()) {
            return <TimelineFrameContentCoxaSpecificInfo />
        }

        switch (data.type) {
            case TYPE_VIDEO_CONFERENCE:
                return <TimelineFrameContentVideoConferenceSpecific />
            case TYPE_GTI:
                return <TimelineFrameContentGTISpecific data={data} isHpa={isHpa} showGtiBeginModal={showGtiBeginModal}/>
            default:
                return <TimelineFrameContentDefaultSpecificInfo />
        }
    }

    return getEventTypeSpecificInformation();
}

const mapStateToProps = (state) => {
    return {
        isHpa: selectIsHpa(state)
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        showGtiBeginModal: () => dispatch(showGtiBeginModal())
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TimelineFrameContentEventSpecificInfo));